import React from 'lib/react';

import { IMaskInput } from 'react-imask';
import PropTypes from 'prop-types';

function MaskedDateInput({
  value,
  onChange,
  id,
  ...rest
}) {
  return (
    <IMaskInput
      mask="0000/00/00"
      value={value}
      overwrite="shift"
      unmask="input"
      prepare={(str) => str.replace(/[^0-9]/gm, '').slice(0, 8)}
      onAccept={(val, mask, event) => {
        if (event) onChange({ target: { id, value: mask.value } });
      }}
      {...rest}
    />
  );
}

MaskedDateInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};
export default MaskedDateInput;
